import request from '@/apis/request'
const resource = 'news' 

export default {
  getNews: (params) => {
    return request.get(`${resource}`, { params })
  }, 
}